import { Button, Input, Modal, Select, Table } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  SET_COMPARED_MEDS,
  UPDATE_COMPARED_MEDS,
} from "../../ActionTypes/ActionTypes";
import "./PrintConfirmationModal.css";

const { Column } = Table;
const { Option } = Select;
const { TextArea } = Input;

class PrintConfirmationModal extends Component {
  state = {
    loading: true,
    edit_pm_id: "",
    reason: "",
    remark: "",
  };

  componentDidMount = () => {
    const { id, setComparedMeds } = this.props;

    setComparedMeds([]);

    axios({
      method: "get",
      url: `/carefills/${id}/check_medicine_inventory.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        setComparedMeds(response.data);
        // console.log('done');
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        setComparedMeds([]);
        // console.log('error');
        this.setState({
          loading: false,
        });
        // alert(error);
      });
  };

  handleReasonChange = (value) => {
    this.setState({
      reason: value,
    });
  };

  handleRemarkChange = (event) => {
    this.setState({
      remark: event.target.value,
    });
  };

  onReasonEdit = (record) => {
    this.setState({
      edit_pm_id: record.prescription_medicine_id,
      reason: record.reason === "null" ? "" : record.reason,
      remark: record.remark === "null" ? "" : record.remark,
    });
  };

  handleRowClass = (record) => {
    // console.log(record.reason);
    if (
      record.reason !== null &&
      record.reason !== "null" &&
      record.reason !== ""
    ) {
      return null;
    }
    if (record.inventorised === 0) {
      return "redBack";
    }
    if (record.inventorised === 1 && record.warn) {
      return "yellowBack";
    }
    return "greenBack";
  };

  handleDisable = () => {
    const { comparedMeds } = this.props;

    let value = false;
    // eslint-disable-next-line
    comparedMeds.map((med) => {
      if ((med.reason === null || med.reason === "") && med.warn) {
        value = true;
      }
    });
    return value;
  };

  onReasonSave = (record) => {
    const { comparedMeds, id, updateComparedMed } = this.props;
    const { edit_pm_id, reason, remark } = this.state;

    if (reason === "" && remark === "") {
      this.setState({
        edit_pm_id: "",
        reason: "",
        remark: "",
      });
      return;
    }

    const data = comparedMeds.filter(
      (med) =>
        Number(med.prescription_medicine_id) ===
        Number(record.prescription_medicine_id)
    )[0];
    const indexToUpdate = comparedMeds.indexOf(data);
    const toBeUpdated = { ...data };
    console.log(reason, remark);
    toBeUpdated.reason = reason === null ? "" : reason;
    toBeUpdated.remark = remark === null ? "" : remark;

    axios({
      method: "put",
      url: `/carefills/${id}/update_inventory_reason.json?prescription_medicine_id=${edit_pm_id}&reason=${reason}&remark=${remark}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then(() => {
        updateComparedMed(indexToUpdate, toBeUpdated);
        this.setState({
          loading: false,
          edit_pm_id: "",
          reason: "",
          remark: "",
        });
      })
      .catch((error) => {
        alert(error);
      });
  };

  render() {
    const { id, visible, onCancel, onCreate, comparedMeds } = this.props;

    const { loading, edit_pm_id, reason, remark } = this.state;

    const reasons = [
      "",
      "Directly given to Patient",
      "Patient has extra meds",
      "Strip can't be cut",
      "Arranged by Patient",
    ];

    const reasonOptions = reasons.map((reas, index) => (
      <Option key={index} value={reas}>
        {reas}
      </Option>
    ));

    return (
      <Modal
        visible={visible}
        title="Medicine In Inventory"
        style={{ textAlign: "center", top: 90 }}
        width="60%"
        onCancel={onCancel}
        onOk={onCreate}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => onCreate(id)}
            disabled={this.handleDisable()}
          >
            Print
          </Button>,
        ]}
      >
        <div>
          <Table
            dataSource={comparedMeds}
            pagination={false}
            loading={loading}
            bordered
            size="middle"
            rowClassName={(record) => this.handleRowClass(record)}
            rowKey="prescription_medicine_id"
          >
            <Column
              title="ID"
              align="center"
              dataIndex="prescription_medicine_id"
              width="75"
            />
            <Column
              title="Medicine Name"
              align="center"
              dataIndex="medicine_name"
              width="300"
            />
            <Column
              title="Quantity"
              align="center"
              width="75"
              render={(record) => (
                <span>
                  {record.inventory_amount} / {record.required_amount}
                </span>
              )}
            />
            <Column
              title="Reasons"
              align="center"
              width="200"
              render={(record) =>
                Number(edit_pm_id) !==
                  Number(record.prescription_medicine_id) ? (
                  record.reason === "null" ? (
                    ""
                  ) : (
                    record.reason
                  )
                ) : (
                  <Select
                    value={reason}
                    style={{ width: 180 }}
                    onChange={(value) =>
                      this.handleReasonChange(
                        value,
                        record.prescription_medicine_id
                      )
                    }
                  >
                    {reasonOptions}
                  </Select>
                )
              }
            />
            <Column
              title="Remark"
              align="center"
              width="200"
              render={(record) =>
                Number(edit_pm_id) !==
                  Number(record.prescription_medicine_id) ? (
                  record.remark === "null" ? (
                    ""
                  ) : (
                    record.remark
                  )
                ) : (
                  <TextArea value={remark} onChange={this.handleRemarkChange} />
                )
              }
            />
            {/* <Column
              title="Actions"
              align="center"
              width="50"
              render={(record) =>
                Number(edit_pm_id) !==
                  Number(record.prescription_medicine_id) ? (
                  <Tooltip placement="top" title="Edit">
                    <span>
                      <a
                        onClick={() => this.onReasonEdit(record)}
                        role="button"
                      >
                        <Icon type="edit" />
                      </a>
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip placement="top" title="Save">
                    <span>
                      <a
                        onClick={() => this.onReasonSave(record)}
                        role="button"
                      >
                        <Icon type="save" />
                      </a>
                    </span>
                  </Tooltip>
                )
              }
            /> */}
          </Table>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  comparedMeds: state.InventoryState.compared_meds,
});

const mapDispatchToProps = (dispatch) => ({
  setComparedMeds: (data) =>
    dispatch({ type: SET_COMPARED_MEDS, payload: { data } }),
  updateComparedMed: (id, values) =>
    dispatch({ type: UPDATE_COMPARED_MEDS, payload: { id, values } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintConfirmationModal);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/PrintConfirmationModal.js